// import { createAxios } from "./base";
import { API } from "aws-amplify";

const workRequest = async (params) => {
  let myInit = {
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    body: {
      data: params
    },
    headers: {} // OPTIONAL
  };
  let items = await API.post("InasakuAPI", "/inasaku/archive/work", myInit);
  return items;
};

const workMonitoring = async (params) => {
  let myInit = { // OPTIONAL
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    queryStringParameters: params, // OPTIONAL
    headers: {}
  };
  let items = await API.get("InasakuAPI", "/inasaku/archive/work", myInit);
  return items;
}

export default {
  workRequest: workRequest,
  workMonitoring: workMonitoring,
};
